// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__28JfB","colMin":"styles_colMin__QiKxc"};